import React, { ReactElement, ReactNode } from "react";
import { Typography } from "@mui/material";

interface InputLabelProps {
	children: ReactNode;
}

const InputLabel = ({ children }: InputLabelProps): ReactElement => {
	return (
		<Typography
			sx={{
				marginBottom: "0.4rem",
			}}
			color="text.secondary"
			variant="h4"
		>
			{children}
		</Typography>
	);
};
export default InputLabel;
